import React from 'react';
const sticker = 'inline-flex items-center rounded-full border-[2.5px] border-ink bg-accent font-sticker font-bold lowercase leading-none text-accent-ink shadow-[3px_3px_0_0_rgb(var(--ink))]';
export function LogoMark({
  className = 'h-9 w-9 text-lg'
}: {
  className?: string;
}) {
  return <span aria-hidden="true" className={`${sticker} -rotate-6 justify-center rounded-[30%] ${className}`} data-id="element-208" data-mp="3v84qh9318wjh">
      lt!
    </span>;
}
export function Logo() {
  return <a href="/" aria-label="LocalTask home" className={`${sticker} -rotate-[4deg] px-3.5 py-1.5 text-lg transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:rotate-[-1deg] hover:shadow-[4px_4px_0_0_rgb(var(--ink))] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[1px_1px_0_0_rgb(var(--ink))]`} data-id="element-209" data-mp="mr1kgtfwzl7e">
      localtask!
    </a>;
}